<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Web Push:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'WebPushCopy')"
            [blockData]="block.variables?.WebPushCopy ?? ''"
            [placeholder]="webPushCopyPlaceHolder"
            [maxLength]="4000"
            variable="WebPushCopy"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'WebPushCta')"
            [blockData]="block.variables?.WebPushCta ?? ''"
            [placeholder]="webPushCtaPlaceHolder"
            [maxLength]="4000"
            variable="WebPushCta"
          ></app-block-text>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'WebPushLink')"
            [blockData]="block.variables?.WebPushLink ?? ''"
            [placeholder]="webPushLinkPlaceHolder"
            [maxLength]="4000"
            variable="WebPushLink"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'WebPushTitle')"
            [blockData]="block.variables?.WebPushTitle ?? ''"
            [placeholder]="webPushTitlePlaceHolder"
            [maxLength]="4000"
            variable="WebPushTitle"
          ></app-block-text>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'WebPushImage')"
            [blockData]="block.variables?.WebPushImage ?? ''"
            [placeholder]="webPushImagePlaceHolder"
            [maxLength]="4000"
            [isImage]="true"
            variable="WebPushImage"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side web-push-text">
        <div class="card">
          <img [src]="$safeNavigationMigration(block.variables?.WebPushImage)" class="img-fluid" />
          <div class="card-body">
            <div class="row mb-3 justify-content-between">

              <div class="col-4">
                <div class="d-flex align-items-center">
                  <img
                    style="width: 20px; height: 20px"
                    src="/assets/images/google-chrome-logo.png"
                  />
                  <p class="mb-0 ms-2">Google Chrome</p>
                </div>
              </div>

              <div class="col-4 text-end">
                <i class="bi bi-three-dots mr-5"></i>
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <!-- <h5
              class="card-title"
              [innerHTML]="block.variables?.WebPushTitle"
            ></h5> -->
            <div class="row g-4 align-items-start">
              <div class="col-auto">
                <img
                  style="width: 80px; height: 80px"
                  src="/assets/images/valamar_logo_80x80.jpg"
                />
              </div>
              <div class="col pt-0">
                <h5
                  class="card-title"
                  [innerHTML]="$safeNavigationMigration(block.variables?.WebPushTitle)"
                ></h5>
                <p
                  class="card-text"
                  [innerHTML]="$safeNavigationMigration(block.variables?.WebPushCopy)"
                ></p>

                <p id="disclaimer-text">www.valamar.com</p>
              </div>
            </div>

            <div class="row align-center justify-content-center">
              <div class="col-6">
                <a
                  target="_blank"
                  [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.WebPushLink))"
                  class="btn btn-light"
                  tabindex="-1"
                  role="button"
                  aria-disabled="true"
                  [innerHTML]="$safeNavigationMigration(block.variables?.WebPushCta)"
                  style="width: 20rem"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
